import * as Yup from 'yup'
import { IReservationModel } from '../../reservation/ReservationModel';
import { IBranchModel } from '../branch/BranchModel';
import { ILocationModel } from '../location/LocationModel';
import { IReservationSource } from '../reservation-source/ReservationSourceModel';

export interface IXmlTariffModel {
  id: string; // BaseEntity'den geldiğini varsayıyorum
  rateName: string,
  dayOne?: number | undefined; // BigDecimal → number, optional yapıldı
  dayTwo?: number | undefined;
  dayThree?: number | undefined;
  dayFour?: number | undefined;
  dayFive?: number | undefined;
  daySix?: number | undefined;
  daySeven?: number | undefined;
  approvalBy?: string;
  actionDate: Date; // LocalDate → YYYY-MM-DD
  startDate: Date;
  endDate: Date;
  maxRentalDate: Date;
  reservationSource?: IReservationSource[];
  status?: boolean;
  tariffType: string;
  tariffSubType: string;
  comparisonSystemDiscountRate?: number; // BigDecimal → number
  actionBranch?: IBranchModel[];
  approvalStatus?: string;
  createdByUsername?: string;
  updatedByUsername?: string;
  specialLocation?: ILocationModel[];
  filters: IXmlTariffFilterModel; // Arama için ek alanlar
}



export const validationXmlTariff = Yup.object().shape({
  rateName: Yup.string().required('Tarife adı zorunludur'),


  startDate: Yup.date()
    .nullable()
    .required('Başlangıç tarihi zorunludur')
    .test('start-before-end', 'Başlangıç tarihi bitiş tarihinden sonra olamaz', function (value) {
      const { endDate } = this.parent;
      return !value || !endDate || new Date(value) <= new Date(endDate);
    }),

  endDate: Yup.date()
    .nullable()
    .required('Bitiş tarihi zorunludur'),
  reservationSource: Yup.array()
    .of(Yup.string())
    .min(1, 'Rezervasyon kaynağı zorunludur'),
  status: Yup.boolean().required('Durum alanı zorunludur'),
  tariffType: Yup.string().required('Tür alanı zorunludur'),
  tariffSubType: Yup.string().required('Alt tür alanı zorunludur'),
  actionBranch: Yup.array()
    .of(Yup.string())
    .min(1, 'İşlem şube alanı zorunludur'),

  // day alanları negatif olamaz — DAILY modunda NaN → null dönüştürmesi yapılır
  dayOne: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').when('tariffSubType', {
    is: (value: string) => value === 'GENERAL' || value === 'SEGMENT',
    then: Yup.number().min(0, 'Negatif olamaz').required('Gün 1 zorunludur'),
    otherwise: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').notRequired(),
  }),
  dayTwo: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').when('tariffSubType', {
    is: (value: string) => value === 'GENERAL' || value === 'SEGMENT',
    then: Yup.number().min(0, 'Negatif olamaz').required('Gün 2 zorunludur'),
    otherwise: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').notRequired(),
  }),
  dayThree: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').when('tariffSubType', {
    is: (value: string) => value === 'GENERAL' || value === 'SEGMENT',
    then: Yup.number().min(0, 'Negatif olamaz').required('Gün 3 zorunludur'),
    otherwise: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').notRequired(),
  }),
  dayFour: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').when('tariffSubType', {
    is: (value: string) => value === 'GENERAL' || value === 'SEGMENT',
    then: Yup.number().min(0, 'Negatif olamaz').required('Gün 4 zorunludur'),
    otherwise: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').notRequired(),
  }),
  dayFive: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').when('tariffSubType', {
    is: (value: string) => value === 'GENERAL' || value === 'SEGMENT',
    then: Yup.number().min(0, 'Negatif olamaz').required('Gün 5 zorunludur'),
    otherwise: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').notRequired(),
  }),
  daySix: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').when('tariffSubType', {
    is: (value: string) => value === 'GENERAL' || value === 'SEGMENT',
    then: Yup.number().min(0, 'Negatif olamaz').required('Gün 6 zorunludur'),
    otherwise: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').notRequired(),
  }),
  daySeven: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').when('tariffSubType', {
    is: (value: string) => value === 'GENERAL' || value === 'SEGMENT',
    then: Yup.number().min(0, 'Negatif olamaz').required('Gün 7 zorunludur'),
    otherwise: Yup.number().nullable().transform((v, o) => (o === '' || Number.isNaN(v) ? null : v)).min(0, 'Negatif olamaz').notRequired(),
  }),
});


export const initialXmlTariff: IXmlTariffModel = {
  id: '',
  rateName: '',  //1
  dayOne: undefined,   //2
  dayTwo: undefined,   //3
  dayThree: undefined,  //4
  dayFour: undefined,   //5
  dayFive: undefined,    //6
  daySix: undefined,    //7
  daySeven: undefined,  //8
  approvalBy: '',   //9
  actionDate: new Date(),  //10
  startDate: new Date(),   // 11
  endDate: new Date(),    // 12
  maxRentalDate: (() => {
    const d = new Date()
    d.setDate(d.getDate() + 365 * 5 + 1)
    return d
  })(),  //14
  reservationSource: [],  // 15 — çoklu rezervasyon kaynağı (id listesi)
  status: false,   // 16
  tariffType: '',   // 17
  tariffSubType: 'GENERAL', // 18
  comparisonSystemDiscountRate: undefined,  // 19 
  actionBranch: [],   // 20 — çoklu işlem şubesi (id listesi)
  approvalStatus: '',   // 21 
  createdByUsername: '',   // 22
  updatedByUsername: '',   // 23
  specialLocation: [],  // 24 — çoklu özel konum (id listesi)
  filters: {
    actionBranchSearch: [], // 25 — arama için ek alan
    reservationSourceSearch: [], // 26 — arama için ek alan
    statusSearch: 'true', // 27 — arama için ek alan
    dateType: '', // 28 — arama için ek alan
    startDateSearch: undefined, // 29 — arama için ek alan
    endDateSearch: undefined, // 30 — arama için ek alan
    approvalStatusSearch: 'APPROVED' // 31 — arama için ek alan
  } // 25 — arama için ek alanlar

}

export interface IXmlTariffFilterModel {
  actionBranchSearch?: string[]; // Arama için ek alan
  reservationSourceSearch?: string[]; // Arama için ek alan
  statusSearch?: string; // Arama için ek alan
  dateType?: string; // Arama için ek alan
  startDateSearch?: Date; // Arama için ek alan
  endDateSearch?: Date; // Arama için ek alan
  approvalStatusSearch?: string; // Arama için ek alan
}


export interface IXmlTariffCalculatePriceModel {
  reservationSourceId: string;  
  startDate: Date;  
  endDate: Date;  
  branchId: string; 
  vehicleGroupId: string;  
  currencyId: string;   
}


// Örnek sabitler
export const STATUS_OPTIONS = [
  { value: true, label: 'Aktif' },
  { value: false, label: 'Pasif' }
] as const


export const TYPE_OPTIONS = [
  { value: 'PRICE', label: 'Fiyat' },
  { value: 'DISCOUNT', label: 'İndirim' },
  { value: 'CAMPAIGN', label: 'Kampanya' }
] as const

export const TARIFF_SUB_TYPE_OPTIONS = [
  { value: 'GENERAL', label: 'Genel' },
  { value: 'DAILY', label: 'Günlük Fiyat' },
  { value: 'SEGMENT', label: 'Segmente Göre' }
] as const

export const APPROVAL_STATUS_OPTIONS = [
  { value: 'NEW', label: 'Yeni' },
  { value: 'APPROVED', label: 'Onaylandı' },
  { value: 'PENDING', label: 'Beklemede' },
  { value: 'REJECTED', label: 'Reddedildi' }
] as const;


export const RESERVATION_SOURCE_OPTIONS = [
  { value: 'ONLINE', label: 'Online' },
  { value: 'PHONE', label: 'Telefon' },
  { value: 'OFFICE', label: 'Ofis' },
  { value: 'AGENCY', label: 'Acenta' },
  { value: 'OTHER', label: 'Diğer' }
] as const


export const RELATED_OFFICE = [{ value: '-1', label: 'Yeni XML Tarifesi' }] as const


